
function initMainHero(){
    console.log('initMainHero()');
// 1) 컨테이너 명시적으로 잡기
    const el = document.getElementById('main-hero-swiper');

    if (el ){
        

        
        // 4) 스와이퍼 생성
        const swiper = new Swiper(el, {
            loop: true,
            effect: 'fade',
            fadeEffect: { crossFade: true },
            speed: 1200,
            autoplay: { delay: 10000, disableOnInteraction: true },
            pagination: {
                type: 'bullets',
                el: el.querySelector('.no-main-hero__pagination'),
                clickable: true
            },
            navigation: {
                nextEl: el.querySelector('.no-main-hero__button--next'),
                prevEl: el.querySelector('.no-main-hero__button--prev')
            },
            on: {
                
            }
        });
    }


    const chatSwiper = new Swiper('#chat-swiper', {
        // loop: true,
        slidesPerView: 3,
        spaceBetween: 80,
        speed: 1200,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        pagination: {
            type: 'bullets',
            el: '.swiper-pagination',
            clickable: true
        },
        breakpoints: {
            320: {
                slidesPerView: 1.25,
                spaceBetween: 20,
            },
            768: {
                slidesPerView: 1.5,
                spaceBetween: 40,
            },
            1024: {
                slidesPerView: 2.5,
                spaceBetween: 60,
            },
            1280: {
                slidesPerView: 3,
                spaceBetween: 80,
            }
        }
    })


    const marginSwiperElements = document.querySelectorAll('.no-margin__swiper');

    marginSwiperElements.forEach(el => {
        new Swiper(el, {
            direction: 'vertical',       // 세로 방향
            slidesPerView: 5,            // 한 번에 보여줄 슬라이드 수 (조정 가능)
            spaceBetween: 16,            // 간격
            loop: true,                  // 무한 루프
            speed: 800,                  // 슬라이드 전환 속도(ms)
            autoplay: {
                delay: 2500,             // 2.5초마다 자동 전환
                disableOnInteraction: false, // 사용자 조작 후에도 계속
                // pauseOnMouseEnter: true,     // 마우스 올리면 멈춤
            },
            allowTouchMove: false,       // 드래그 비활성화 (자동 롤링 느낌)
            freeMode: false,
            mousewheel: false,
        });
    });



    const peopleSection = document.querySelector('.no-main-team');
    const peopleSvg     = document.querySelector('.no-main-team__line svg');

    if (peopleSection && peopleSvg) {
    // 1) SVG 내 그릴 대상 수집
    const elems = peopleSvg.querySelectorAll('path, line, polyline, polygon, circle, ellipse, rect');

    // 2) 길이 계산 + 초기 상태(안 그려진 상태) 세팅
    elems.forEach(el => {
        let len = 0;
        if (typeof el.getTotalLength === 'function') {
        len = el.getTotalLength();
        } else if (el.tagName === 'rect') {
        const w = parseFloat(el.getAttribute('width'))  || 0;
        const h = parseFloat(el.getAttribute('height')) || 0;
        len = 2 * (w + h);
        }
        el.dataset._dash = len; // 캐시
        gsap.set(el, {
        strokeDasharray: len,
        strokeDashoffset: len,
        // 선택: 선이 보장되도록
        // stroke: el.getAttribute('stroke') || 'currentColor'
        });
    });

    // 3) 스크롤에 따라 dashoffset을 0으로 (그려지기)
    //    한 번에 전체를 그리려면 타임라인으로 묶고, 경로마다 살짝 스태거
    const tl = gsap.timeline({
        defaults: { ease: 'none' },
        scrollTrigger: {
        trigger: peopleSection,
        start: 'top 80%',     // 섹션 상단이 뷰포트 80% 위치에 올 때 시작
        end:   'bottom bottom',  // 섹션 하단이 뷰포트 40% 위치에 올 때 끝
        scrub: true,          // 스크롤 연동
        // once: false         // 한 번만 재생하려면 true로
        }
    });

    elems.forEach((el, i) => {
        const len = parseFloat(el.dataset._dash) || 0;
        tl.to(el, { strokeDashoffset: 0, duration: 1 }, i * 0.08); // 살짝 순차로
    });
    }


    // horizontal scroll
    const container = document.querySelector('.no-main-interior');
    const wrapper = document.querySelector('.no-main-interior__wrapper');
    const items = [...document.querySelectorAll('.no-main-interior__item')];

    if (!wrapper || items.length === 0) return;
    const getDisance = () => {
            
        const totalWidth = wrapper.scrollWidth + (window.innerWidth >= 768 ? (window.innerWidth / 4) : 1 );
        const viewportWidth = window.innerWidth;
        const scrollDistance = totalWidth - viewportWidth;

        return scrollDistance; 
    }

    gsap.timeline({
        scrollTrigger: {
            trigger: container,
            start: "top top",
            end: () => {

                return `+=${getDisance()}`
            },
            scrub: true,
            pin: true,
            anticipatePin: 1,
        }
    }).to(wrapper, {
        x: -getDisance(),
        ease: "none",
        duration: 5,
    });

}


function initMarquee(){
    const marquee = document.querySelectorAll('.no-marquee');
    
    if(!marquee) return;

    function runMarquee() {
        let speed = window.innerWidth <= 768 ? 15 : 25;

        $('.no-marquee__container').marquee('destroy').marquee({
            direction: 'left',
            speed: speed,
            gap: 24,
            duplicated: true,
            pauseOnHover: true,
            startVisible: true,
        });
    }

    $(document).ready(function () {
        runMarquee();
    });

    $(window).resize(function () {
        runMarquee();
    });

}

function initClnicIntro () {
    
    const swiper = new Swiper(".thumb-swiper", {
        spaceBetween: 10,
        slidesPerView: 6,
        freeMode: true,
        watchSlidesProgress: true,
        breakpoints: {
            0: {
                spaceBetween: 5,
                slidesPerView: 4,
            },
            768: {
                spaceBetween: 10,
                slidesPerView: 6,
            }
        }
    });
    const swiper2 = new Swiper(".control-swiper", {
        spaceBetween: 10,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        thumbs: {
            swiper: swiper,
        },
    });
    
}

function initLenis(){
    const lenis = new Lenis();
    console.log(lenis);
    

    lenis.on("scroll", (e) => {
        ScrollTrigger.update();
    });

    gsap.ticker.add((time) => {
        lenis.raf(time * 1000);
    });

    gsap.ticker.lagSmoothing(0);
}

function initMainPofol(){
    console.log('initMainPofol()');
    const SELECTOR = '#main-pofol-swiper';

    const el = document.querySelector(SELECTOR);
    if (!el) return; 

    const swiper = new Swiper(el, {
        slidesPerView: 4,
        spaceBetween: 24,
        navigation: {
            nextEl: ".no-main-pofol__button--next",
            prevEl: ".no-main-pofol__button--prev",
        },
        breakpoints: {
            320: {
                slidesPerView: 1.5
            },
            544: {
                slidesPerView: 2.5
            },
            768: {
                slidesPerView: 3.5
            },
            1024: {
                slidesPerView: 4
            },
        }
    });

}



function initMainResource(){
    console.log('initMainResource()');
    const SELECTOR = '#main-resource-swiper';

    const el = document.querySelector(SELECTOR);
    if (!el) return; 

    const swiper = new Swiper(el, {
        slidesPerView: 4,
        spaceBetween: 24,
        breakpoints: {
            320: {
                slidesPerView: 1.5
            },
            544: {
                slidesPerView: 2.5
            },
            768: {
                slidesPerView: 1.5
            },
            1024: {
                slidesPerView: 2.5
            },
        }
    });

}


function initSubNav(){
    console.log('initSubNav()');
    const SELECTOR = '#sub-nav-swiper';

    const el = document.querySelector(SELECTOR);
    if (!el) return; 

    const swiper = new Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: 8,
        navigation: {
            nextEl: ".no-sub-nav__button--next",
            prevEl: ".no-sub-nav__button--prev",
        },
        on: {
            init(){
                const activeIndex = this.slides.findIndex(slide => slide.classList.contains('--active')); 
                
                if (activeIndex === -1) return; 

                this.slideTo(activeIndex);
                
            }
        }
    });

}

function initHeader(){
    console.log('initHeader()');
    
    const header = document.getElementById('main-header');

    if (!header) return; 

    const nav = header.querySelector('.no-header__nav'); 

    if(!nav) return; 

    const tl = gsap.timeline({paused: true});

    tl.to(header, {
        height: () => {
            return nav.offsetHeight + 'px'
        },
        ease: 'power3.inOut'
    });

    const onEnter = () => {
        header.setAttribute('aria-expanded', true);
        tl.play();
    } 
    
    const onLeave = () => {
        header.removeAttribute('aria-expanded');
        tl.reverse(); 
    }

    nav.addEventListener('mouseenter', onEnter);
    header.addEventListener('mouseleave', onLeave);

    window.addEventListener('resize', (e) => {
        if (window.innerWidth <= 1024) {
            header.removeAttribute('style'); 
            header.removeAttribute('aria-expanded');
        }
    });

    const drawer = document.getElementById('main-drawer');
    console.log(drawer);
    
    if(!drawer) return; 

    const drawerOpenBtn = header.querySelector('.no-header__toggle')
    const drawerCloseBtn = drawer.querySelector('.no-drawer__toggle');


    const drawerTl = gsap.timeline({paused: true}); 
    drawerTl.to(drawer, {
        x: '0%',
        opacity: 1,
        ease:'power3.inOut'
    })

    const onOpen = () => {
        document.body.classList.add('--hidden');
        drawerTl.play();
    }
    
    const onClose = () => {
        document.body.classList.remove('--hidden');
        drawerTl.reverse();
    }

    drawerOpenBtn.addEventListener('click', onOpen); 
    drawerCloseBtn.addEventListener('click', onClose); 
}

function initFloatMenu(){
    const container = document.querySelector('.no-floating-container');
    const menu      = document.querySelector('.no-floating-menu');
    if (!container || !menu) return;

    const PIN_OFFSET = 100;            // 고정 시작 보정 (헤더 높이 등)
    const SCROLL_OFFSET = PIN_OFFSET;  // 섹션 이동 시 상단 여백(고정헤더 고려)

    gsap.registerPlugin(ScrollTrigger);

    // 메뉴 고정
    ScrollTrigger.create({
        trigger: container,
        start: `top+=${PIN_OFFSET} top`,
        end: 'bottom bottom',
        pin: menu,
        pinSpacing: false,
        anticipatePin: 1,
        invalidateOnRefresh: true
    });

    // ============ Active 처리 ============

    const links = Array.from(menu.querySelectorAll('.no-floating-menu__link'));

    // href에서 해시만 뽑아 섹션 매핑
    const items = links
        .map(link => {
        try {
            const url = new URL(link.href, location.origin);
            const hash = url.hash?.replace('#','') || '';
            if (!hash) return null;
            const section = document.getElementById(hash);
            if (!section) return null;
            return { link, section, hash };
        } catch(e){
            return null;
        }
        })
        .filter(Boolean);

    const clearActive = () => {
        links.forEach(a => a.classList.remove('--active'));
    };
    const setActive = (link) => {
        if (!link) return;
        clearActive();
        link.classList.add('--active');
    };

    // 섹션별 트리거 생성 (섹션이 뷰포트 중앙에 가까울 때 활성화)
    items.forEach(({ link, section }) => {
        ScrollTrigger.create({
        trigger: section,
        start: `top+=${SCROLL_OFFSET} center`,
        end: `bottom center`,
        onEnter: () => setActive(link),
        onEnterBack: () => setActive(link),
        // 섹션 높이 변화 대응
        invalidateOnRefresh: true
        });
    });

    // 초기 로드 시 현재 위치 기준으로 활성화 보정
    requestAnimationFrame(() => ScrollTrigger.refresh());
    // ============ 클릭 시 스무스 스크롤 ============

    const scrollToSection = (el) => {
        const top = el.getBoundingClientRect().top + window.pageYOffset - SCROLL_OFFSET;
        window.scrollTo({ top, behavior: 'smooth' });
    };

    links.forEach(a => {
        a.addEventListener('click', (e) => {
        const hash = (new URL(a.href, location.origin)).hash.replace('#','');
        const target = document.getElementById(hash);
        if (target) {
            e.preventDefault();
            scrollToSection(target);
            // 즉시 시각 피드백
            setActive(a);
            history.replaceState(null, '', `#${hash}`);
        }
        });
    });


    // 이미지/폰트 등 지연 로드로 레이아웃 변할 때 재계산
    window.addEventListener('load', () => ScrollTrigger.refresh());

    
    setTimeout(() => {
       const currentHash = location.hash?.replace('#','');
        
        if (currentHash) {
            const target = document.getElementById(currentHash);
            
            if (target) {
                scrollToSection(target);
                const found = items.find(i => i.hash === currentHash);
                if (found) setActive(found.link);
            }
        } 
    }, 300);

}

async function initCaptcha() {
  console.log('initCaptcha()');

  const img     = document.getElementById('captcha-img');
  const refresh = document.getElementById('captcha-refresh');
  const listen  = document.getElementById('captcha-listen');
  const audioEl = document.getElementById('captcha-audio');

  if (!img || !refresh || !listen || !audioEl) return;

  const listenIcon = listen.querySelector('i');
  let isPlaying = false;

  function resetAudio() {
    try { audioEl.pause(); } catch(e) {}
    audioEl.removeAttribute('src');
    audioEl.load();
    isPlaying = false;
    if (listenIcon) {
      listenIcon.classList.remove('fa-volume-slash');
      listenIcon.classList.add('fa-volume');
    }
  }

  function refreshCaptcha() {
    // 오디오 재생 중이면 초기화
    resetAudio();
    // 캐시 무력화
    img.src = '/inc/lib/captcha.image.php?_=' + Date.now();
  }

  async function toggleAudio() {
    if (isPlaying) {
      // 현재 재생 중 → 멈춤
      resetAudio();
      return;
    }

    try {
      listen.disabled = true;
      const url = '/inc/lib/captcha.audio.php?_=' + Date.now();

      resetAudio(); // 혹시 모를 잔여 상태 초기화
      audioEl.src = url;

      await audioEl.play();
      isPlaying = true;

      if (listenIcon) {
        listenIcon.classList.remove('fa-volume');
        listenIcon.classList.add('fa-volume-slash');
      }

      // 재생이 끝나면 상태 원복
      audioEl.onended = () => {
        resetAudio();
      };

    } catch (err) {
      console.error(err);
      alert('오디오를 재생할 수 없습니다.');
      resetAudio();
    } finally {
      listen.disabled = false;
    }
  }

  // 초기 표시
//   refreshCaptcha();

  // 이벤트 바인딩
  refresh.addEventListener('click', refreshCaptcha);
  listen.addEventListener('click', toggleAudio);

  // 새로고침 버튼 키보드 접근성
  refresh.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      refreshCaptcha();
    }
  });
}

function initGoToTop(){
    const root   = document.getElementById('gototop');               // .no-gototop 래퍼
    const button = root?.querySelector('#go-to-top-up');
    if (!root || !button) return;

    // 접근성 속성
    button.setAttribute('aria-label', '맨 위로 이동');
    root.setAttribute('aria-hidden', 'true');

    const THRESHOLD = 200;     // 몇 px 내렸을 때 보일지
    let ticking = false;

    function toggle() {
        const shouldShow = window.scrollY > THRESHOLD;
        if (shouldShow) {
        root.classList.add('is-visible');
        root.setAttribute('aria-hidden', 'false');
        } else {
        root.classList.remove('is-visible');
        root.setAttribute('aria-hidden', 'true');
        }
    }

    function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
        toggle();
        ticking = false;
        });
    }

    // 클릭 시 스크롤 맨 위
    function scrollTopSmooth() {
        const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({
        top: 0,
        behavior: prefersReduced ? 'auto' : 'smooth'
        });
    }

    // 키보드 접근성 (Enter/Space)
    function onKey(e) {
        if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        scrollTopSmooth();
        }
    }

    // 초기 상태 & 이벤트
    toggle();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    button.addEventListener('click', scrollTopSmooth);
    button.addEventListener('keydown', onKey);
}

function initBaseFaq() {
    const lists = document.querySelectorAll('.no-faq__list');
    if (!lists.length) return;

    lists.forEach(list => {
        // data-accordion="multiple" 이면 여러 개 동시 열림 허용
        const allowMultiple = (list.getAttribute('data-accordion') === 'multiple');

        const items = Array.from(list.querySelectorAll('.no-faq__item'));
        if (!items.length) return;

        // 유틸
        const collapse = (item) => {
            if (!item.classList.contains('--active')) return;
            const head = item.querySelector('.no-faq__head');
            const body = item.querySelector('.no-faq__body');
            item.classList.remove('--active');
            if (head) head.setAttribute('aria-expanded', 'false');
            if (body) body.style.maxHeight = '';
        };

        const expand = (item) => {
            if (item.classList.contains('--active')) return;
            const head = item.querySelector('.no-faq__head');
            const body = item.querySelector('.no-faq__body');
            item.classList.add('--active');
            if (head) head.setAttribute('aria-expanded', 'true');
            if (body) body.style.maxHeight = body.scrollHeight + 'px';
        };

        // 초기화 + 접근성 속성
        items.forEach((item, idx) => {
            const head = item.querySelector('.no-faq__head');
            const body = item.querySelector('.no-faq__body');
            if (!head || !body) return;

            // body id 보장 + head와 연결
            if (!body.id) body.id = `faq-body-${Math.random().toString(36).slice(2)}`;
            head.setAttribute('aria-controls', body.id);
            head.setAttribute('aria-expanded', item.classList.contains('--active') ? 'true' : 'false');
            head.setAttribute('type', 'button'); // 안전빵

            // 활성 아이템의 높이 초기 세팅
            if (item.classList.contains('--active')) {
                body.style.maxHeight = body.scrollHeight + 'px';
            } else {
                body.style.maxHeight = '';
            }

            head.addEventListener('click', () => {
                const isActive = item.classList.contains('--active');

                if (!allowMultiple) {
                    // 단일 열림 모드면 다른 아이템 닫기
                    items.forEach(i => { if (i !== item) collapse(i); });
                }

                isActive ? collapse(item) : expand(item);
            });
        });

        // 리사이즈 시 열린 항목 높이 재계산(이미지 로드 등 레이아웃 변화 대응)
        let resizeRaf = null;
        const onResize = () => {
            if (resizeRaf) return;
            resizeRaf = requestAnimationFrame(() => {
                items.forEach(item => {
                    if (item.classList.contains('--active')) {
                        const body = item.querySelector('.no-faq__body');
                        if (body) body.style.maxHeight = body.scrollHeight + 'px';
                    }
                });
                resizeRaf = null;
            });
        };
        window.addEventListener('resize', onResize, { passive: true });
        window.addEventListener('load', onResize);
    });
}
function initBeforeAfterFaq() {
    const lists = document.querySelectorAll('.no-main-compare__items');
    if (!lists.length) return;

    lists.forEach(list => {
        const allowMultiple = (list.getAttribute('data-accordion') === 'multiple');
        const items = Array.from(list.querySelectorAll('.no-main-compare__item'));
        if (!items.length) return;

        const collapse = (item) => {
            if (!item.classList.contains('--active')) return;
            const head = item.querySelector('.no-main-compare__head');
            const body = item.querySelector('.no-main-compare__body');
            item.classList.remove('--active');
            if (head) head.setAttribute('aria-expanded', 'false');
            if (body) body.style.maxHeight = '';
        };

        const expand = (item) => {
            if (item.classList.contains('--active')) return;
            const head = item.querySelector('.no-main-compare__head');
            const body = item.querySelector('.no-main-compare__body');
            item.classList.add('--active');
            if (head) head.setAttribute('aria-expanded', 'true');

            // 이미지가 늦게 로드될 수 있어 두 번 계산
            if (body) {
                body.style.maxHeight = body.scrollHeight + 'px';
                // 한 프레임 뒤 재계산(이미지 onload 직후 반영용)
                requestAnimationFrame(() => {
                    body.style.maxHeight = body.scrollHeight + 'px';
                });
            }
        };

        // 초기화 + 접근성
        items.forEach((item) => {
            const head = item.querySelector('.no-main-compare__head');
            const body = item.querySelector('.no-main-compare__body');
            if (!head || !body) return;

            // body id 연결
            if (!body.id) body.id = `ba-body-${Math.random().toString(36).slice(2)}`;
            head.setAttribute('aria-controls', body.id);
            head.setAttribute('aria-expanded', item.classList.contains('--active') ? 'true' : 'false');
            head.setAttribute('type', 'button');

            // 활성 항목은 높이 세팅
            if (item.classList.contains('--active')) {
                body.style.maxHeight = body.scrollHeight + 'px';
            } else {
                body.style.maxHeight = '';
            }

            // 클릭 토글
            head.addEventListener('click', () => {
                const isActive = item.classList.contains('--active');
                if (!allowMultiple) {
                    items.forEach(i => { if (i !== item) collapse(i); });
                }
                isActive ? collapse(item) : expand(item);
            });

            // 키보드 접근성(Enter/Space)
            head.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    head.click();
                }
            });

            // 내부 이미지 로드 시 높이 재계산
            body.querySelectorAll('img').forEach(img => {
                img.addEventListener('load', () => {
                    if (item.classList.contains('--active')) {
                        body.style.maxHeight = body.scrollHeight + 'px';
                    }
                }, { passive: true });
            });
        });

        // 리사이즈 시 열린 항목 높이 갱신
        let raf = null;
        const onResize = () => {
            if (raf) return;
            raf = requestAnimationFrame(() => {
                items.forEach(item => {
                    if (item.classList.contains('--active')) {
                        const body = item.querySelector('.no-main-compare__body');
                        if (body) body.style.maxHeight = body.scrollHeight + 'px';
                    }
                });
                raf = null;
            });
        };
        window.addEventListener('resize', onResize, { passive: true });
        window.addEventListener('load', onResize);
    });
}

function initProcess (){
    const list = document.querySelector('.no-serv-core__list');
  if (!list) return;

  const items = [...list.querySelectorAll('.no-serv-core__item')];
  let idx = 0, timer = null, started = false;

  const activate = (i) => {
    items.forEach((el, j) => el.classList.toggle('is-active', j === i));
    idx = i;
  };

  const startLoop = () => {
    if (started || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    started = true;
    activate(0);
    timer = setInterval(() => activate((idx + 1) % items.length), 2400);
  };

  const stopLoop = () => { if (timer) { clearInterval(timer); timer = null; } };

  // 뷰포트에 들어오면 시작, 나가면 정지
  const io = new IntersectionObserver(([ent]) => {
    if (ent.isIntersecting) startLoop();
    else { stopLoop(); items.forEach(el => el.classList.remove('is-active')); started = false; }
  }, { threshold: 0.5 });
  io.observe(list);

  // 호버 시 해당 항목 고정(모바일 탭도 대응)
//   items.forEach((el, i) => {
//     el.addEventListener('mouseenter', () => { stopLoop(); activate(i); });
//     el.addEventListener('mouseleave', () => { startLoop(); });
//     el.addEventListener('click', () => { stopLoop(); activate(i); });
//   });
}


function initSummary(){
  const root = document.querySelector('.no-main-summary');
  if (!root) return;

  const counters = root.querySelectorAll('.counter');
  if (!counters.length) return;

  // gsap effect 1회 등록
  if (!gsap.effects?.countTo) {
    gsap.registerEffect({
      name: 'countTo',
      defaults: { end: 0, duration: 0.8, ease: 'power1.out', increment: null },
      extendTimeline: false,
      effect: (targets, cfg) => {
        const el = targets[0];
        const raw = String(cfg.end);
        const decimals = (raw.split('.')[1] || '').length;

        // 증분 스냅(지정 없으면 소수자릿/규모에 맞춰 자동)
        const step = cfg.increment != null
          ? Number(cfg.increment)
          : (decimals > 0 ? Math.pow(10, -decimals) : 1);

        const format = (v) => {
          const n = Number(v);
          if (!Number.isFinite(n)) return v;
          return n
            .toFixed(decimals)
            .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        };

        return gsap.to(el, {
          duration: cfg.duration,
          ease: cfg.ease,
          innerText: cfg.end,
          modifiers: {
            innerText: (val) => {
              const snapped = gsap.utils.snap(step, Number(val));
              return format(snapped);
            }
          }
        });
      }
    });
  }

  const play = () => {
    counters.forEach((el) => {
      if (el.dataset.counterDone === '1') return;

      const end = parseFloat(el.textContent.trim().replace(/,/g, ''));
      if (!Number.isFinite(end)) return;

      const decimals = (String(end).split('.')[1] || '').length;
      el.textContent = (0).toFixed(decimals);

      gsap.effects.countTo(el, {
        end,
        duration: Number(el.dataset.duration ?? 0.8),
        ease: String(el.dataset.ease ?? 'power1.out'),
        increment: el.dataset.increment != null ? Number(el.dataset.increment) : null
      });

      el.dataset.counterDone = '1';
    });
  };

  // 처음부터 화면 안이면 즉시 실행, 아니면 교차옵저버로 1회 실행
  const isInView = () => {
    const r = root.getBoundingClientRect();
    return r.top < window.innerHeight && r.bottom > 0;
  };

  if (isInView()) {
    play();
  } else {
    const io = new IntersectionObserver((ents) => {
      ents.forEach((ent) => {
        if (ent.isIntersecting) {
          play();
          io.disconnect();
        }
      });
    }, { threshold: 0.2 });
    io.observe(root);
  }
}
function initDrawLine() {
  const wrappers = document.querySelectorAll('.no-line-text');
  if (!wrappers.length || !window.gsap) return;

  if (window.ScrollTrigger) gsap.registerPlugin(ScrollTrigger);

  wrappers.forEach((wrap) => {
    const svg  = wrap.querySelector('svg');
    const path = svg?.querySelector('path');
    if (!svg || !path) return;

    // 1) 대상 path의 bbox 구해서 그만큼을 가리는 clip rect 준비
    const bb = path.getBBox();
    // bbox가 0이면(비보이는 path 등) 안전탈출
    if (!bb.width || !bb.height) return;

    // <defs> 보장
    let defs = svg.querySelector('defs');
    if (!defs) {
      defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
      svg.insertBefore(defs, svg.firstChild);
    }

    // 고유 clipPath + rect 생성 (userSpaceOnUse로 실제 px 단위 사용)
    const clipId = `clip-fill-${Math.random().toString(36).slice(2)}`;
    const cp   = document.createElementNS('http://www.w3.org/2000/svg', 'clipPath');
    const rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
    cp.setAttribute('id', clipId);
    cp.setAttribute('clipPathUnits', 'userSpaceOnUse');

    // 처음엔 폭 0 (왼쪽에서 시작)
    rect.setAttribute('x', bb.x);
    rect.setAttribute('y', bb.y);
    rect.setAttribute('width', 0);
    rect.setAttribute('height', bb.height);

    cp.appendChild(rect);
    defs.appendChild(cp);

    // path에 clipPath 적용 (fill은 그대로 둔다)
    path.setAttribute('clip-path', `url(#${clipId})`);

    // 2) 스크롤 트리거로 rect.width를 bbox.width까지 애니메이션
    gsap.to(rect, {
      attr: { width: bb.width },             // ← fill이 왼→오로 드러남
      duration: Number(wrap.dataset.duration || 1.2),
      ease: wrap.dataset.ease || 'power3.out',
      immediateRender: false,
      overwrite: 'auto',
      scrollTrigger: window.ScrollTrigger ? {
        trigger: wrap.closest('section') || wrap,
        start: 'top center',
        once: true
      } : undefined
    });
  });
}


/**
 * no-main-about 섹션 내 3개의 SVG 차트를 애니메이션
 * - 1번째(막대): 파란 막대 상승, 배지 팝업
 * - 2번째(라인): 선이 그려지고 면적 채워짐, 포인트 점 팝업
 * - 3번째(게이지/화살표): 회색/파란 바 채움, 화살표 슬라이드
 */
function initAboutChart(root = document) {
  gsap.registerPlugin(ScrollTrigger);

  const svgs = root.querySelectorAll('.no-main-about__image svg');
  if (svgs.length < 3) return; // 안전장치

  const [barSvg, lineSvg, timeSvg] = svgs;

  // 공통 유틸
  const bbox = el => {
    try { return el.getBBox(); } catch { return {width:0,height:0};}
  };
  const isTall = el => {
    const b = bbox(el);
    return b.height > b.width && b.height > 30;
  };
  const isWide = el => {
    const b = bbox(el);
    return b.width > b.height && b.width > 100;
  };

  // ---------- 1) 막대 차트 ----------

(function animateBars(svg){
  if (!svg) return;

  // bbox 유틸
  const bbox = el => { try { return el.getBBox(); } catch { return {width:0,height:0}; } };
  const isTall = el => { const b = bbox(el); return b.height > b.width && b.height > 30; };
  const isSmallTriangle = el => { const b = bbox(el); return b.width <= 24 && b.height <= 20; };

  // 막대
  const blueBars = Array.from(svg.querySelectorAll('rect[fill="#2652A3"], path[fill="#2652A3"]')).filter(isTall);
  const grayBars = Array.from(svg.querySelectorAll('rect[fill="#DFDFDF"], path[fill="#DFDFDF"]')).filter(isTall);

  // 배지(520/450/530): 파란 요소 전체에서 막대/삼각형 제외
  const blueAll = Array.from(svg.querySelectorAll('[fill="#2652A3"]'));
  const pillTriangles = blueAll.filter(isSmallTriangle);
  const pills = blueAll.filter(el => !isTall(el) && !isSmallTriangle(el));

  // 배지 안 흰색 숫자/문자
  const pillTexts = svg.querySelectorAll('path[fill="white"]');

  const tl = gsap.timeline({
    paused: true,
    defaults: { ease: "power3.out", duration: 0.9 },
    scrollTrigger: { trigger: svg, start: "top 75%", once: true }
  });

  // 1) 회색 막대 (이전)
  gsap.set(grayBars, { transformOrigin: "50% 100%", transformBox: "fill-box", scaleY: 0.001 });
  tl.to(grayBars, { scaleY: 1, stagger: 0.06, duration: 0.6, ease: "power2.out" }, 0);

  // 2) 파란 막대 (이후)
  gsap.set(blueBars, { transformOrigin: "50% 100%", transformBox: "fill-box", scaleY: 0.001 });
  tl.to(blueBars, { scaleY: 1, stagger: 0.09 }, 0.1);

  // 3) 배지(세 개 모두) 팝업
  gsap.set(pills, { y: 10, scale: 0.9, opacity: 0, transformBox: "fill-box", transformOrigin: "50% 50%" });
  gsap.set(pillTriangles, { y: 10, opacity: 0, transformBox: "fill-box" });
  gsap.set(pillTexts, { opacity: 0 });

  tl.to(pills, { y: 0, scale: 1, opacity: 1, duration: 0.5, ease: "back.out(1.8)", stagger: 0.08 }, 0.35)
    .to(pillTriangles, { y: 0, opacity: 1, duration: 0.45, stagger: 0.08 }, 0.38)
    .to(pillTexts, { opacity: 1, duration: 0.3, stagger: 0.02 }, 0.42);
})(barSvg);


  // ---------- 2) 라인 차트 ----------
  (function animateLine(svg){
    if (!svg) return;

    // 선(스트로크 파랑)
    const linePath = svg.querySelector('path[stroke="#2652A3"], polyline[stroke="#2652A3"]');

    // 면적(밑에 채워지는 연한 파랑)
    const area = svg.querySelector('[fill="#E6EEFB"]');

    // 포인트 점
    const dots = svg.querySelectorAll('circle[fill="#2652A3"]');

    const tl = gsap.timeline({
      paused: true,
      scrollTrigger: {
        trigger: svg,
        start: "top 75%",
        once: true
      }
    });

    // 면적 채움 (아래에서 위로)
    if (area) {
      gsap.set(area, { transformOrigin: "50% 100%", transformBox: "fill-box", scaleY: 0.001, opacity: 0.001 });
      tl.to(area, { scaleY: 1, opacity: 1, duration: 0.9, ease: "power3.out" }, 0);
    }

    // 선 그리기
    if (linePath && linePath.getTotalLength) {
      const len = linePath.getTotalLength();
      gsap.set(linePath, { strokeDasharray: len, strokeDashoffset: len, opacity: 1 });
      tl.to(linePath, { strokeDashoffset: 0, duration: 1.2, ease: "power2.out" }, 0.05);
    }

    // 포인트 점/라벨 등장
    gsap.set(dots, { scale: 0, transformOrigin: "50% 50%" });
    tl.to(dots, { scale: 1, stagger: 0.06, duration: 0.35, ease: "back.out(2)" }, 0.3);
  })(lineSvg);

  // ---------- 3) 체류시간/게이지 ----------
  (function animateTime(svg){
    if (!svg) return;

    // 넓은 회색 바(이전)
    const grayWide = Array.from(svg.querySelectorAll('[fill="#DFDFDF"]')).filter(isWide)[0];

    // 넓은 파란 바(이후)
    const blueWide = Array.from(svg.querySelectorAll('[fill="#2652A3"]')).filter(isWide)[0];

    // 화살표(파란 화살표/사각형 그룹) — 파란 도형들 중, 가장 넓은 바(blueWide)를 제외한 것들
    const blueShapes = Array.from(svg.querySelectorAll('path[fill="#2652A3"], rect[fill="#2652A3"]'))
      .filter(el => el !== blueWide);

    const tl = gsap.timeline({
      paused: true,
      defaults: { ease: "power3.out" },
      scrollTrigger: {
        trigger: svg,
        start: "top 75%",
        once: true
      }
    });

    // 회색 바 채움
    if (grayWide) {
      gsap.set(grayWide, { transformOrigin: "0% 50%", transformBox: "fill-box", scaleX: 0.001 });
      tl.to(grayWide, { scaleX: 1, duration: 0.6 }, 0);
    }

    // 파란 바 채움 (뒤이어 더 강하게)
    if (blueWide) {
      gsap.set(blueWide, { transformOrigin: "0% 50%", transformBox: "fill-box", scaleX: 0.001 });
      tl.to(blueWide, { scaleX: 1, duration: 0.9 }, 0.15);
    }

    // 화살표/배지 슬라이드-인
    if (blueShapes.length) {
      gsap.set(blueShapes, { x: -16, opacity: 0, transformBox: "fill-box" });
      tl.to(blueShapes, { x: 0, opacity: 1, duration: 0.5, stagger: 0.05 }, 0.2);
    }
  })(timeSvg);
}


function app(){
    console.log('app()');
    
    document.addEventListener('DOMContentLoaded', () => {
        initLenis();
        initMainHero();
        initMainPofol(); 
        initMainResource();
        initSubNav(); 
        initHeader(); 
        initFloatMenu();
        initCaptcha();
        initGoToTop();
        initClnicIntro(); 
        initMarquee(); 
        initBaseFaq(); 
        initBeforeAfterFaq(); 



        AOS.init();
        initAboutChart();
        initSummary();
        initProcess(); 
        initDrawLine(); 
        
    });
}
app();